import { Box, Checkbox, Grid, Typography } from '@mui/material';
import { KeyValue } from './contributor';
import { Notes, SubHeading } from '../../../investors/components';
import React, { useEffect, useState } from 'react';
import { Gridstyles } from './index';
import { Applicant, BrokerList } from '../../../../redux-store/types/api-types';
import { formatShortDate } from '../../../../utils/date';
import { getPEPStatus } from '../../../NonIndividualApplicationDetails/ContributorDetails';
import {
  currencyConversion,
  getclIdField,
  getdpIdField,
  isCDSL,
  isPhysicallyChallenged,
} from '../../../../utils/utilityFunctions';
import { SourceOfFundMaster, YesNoMaster } from '../../../../utils/constant';
import { DLCLMasters } from '../../../../utils/constant';
import { useDispatch } from 'react-redux';
import { getBrokers } from '../../../../redux-store/actions/application';

export default function KycDetails({
  applicants = [],
}: {
  applicants: Partial<Applicant>[];
}): JSX.Element {
  const [brokerList, setBrokerList] = useState<BrokerList>();
  const dispatch = useDispatch();
  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getBrokers())) as unknown as BrokerList;
        setBrokerList(response as BrokerList);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
              Additional KYC Details
            </Typography>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First Applicant Details',
                'Second Applicant Details',
                'Third Applicant Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading sx={{ letterSpacing: 0.5 + 'px' }}>{title}</SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={15}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue
                        title={'Occupation Details'}
                        description={applicant.occupationDetails}
                      />
                      <KeyValue
                        title={'Gross Annual Income'}
                        description={applicant.grossAnnualIncome}
                      />
                      <KeyValue
                        title={'Net Worth'}
                        description={currencyConversion(applicant.netWorth)}
                      />
                      <KeyValue
                        title={'Net worth as on'}
                        description={formatShortDate(applicant.netWorthDate)}
                      />
                      {/*<KeyValue
                        title={'Net Worth Date'}
                        description={formatShortDate(applicant.netWorthDate)}
                      /> */}
                      <KeyValue
                        title={'Politically Exposed Person (PEP) Status'}
                        description={getPEPStatus(applicant.politicallyExposedPersonStatus || '')}
                      />
                      <KeyValue title={'CKYC Number'} description={applicant.ckycNo} />
                      <KeyValue
                        title={'Demat Account Details (for allotment of units)'}
                        description={DLCLMasters[applicant.dlclId || '']}
                      />
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title={isCDSL(applicant.dlclId || '') ? 'DPCL ID' : 'DP ID'}
                          description={applicant.dpId}
                        />
                      )}
                      {getclIdField(applicant.dlclId || '') && (
                        <KeyValue title={'CL ID'} description={applicant.clId} />
                      )}
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title={'Name of Broker/Depository Participant (DP)'}
                          description={
                            brokerList?.broker_list.find(
                              (broker) => broker.key === applicant.nameOfBroker
                            )?.value
                          }
                        />
                      )}
                      {applicant.sourceOfFundsDeclaration && (
                        <>
                          <Grid item xs={12} display="flex" alignItems={'flex-start'} my={2}>
                            <Checkbox defaultChecked disabled={true} />
                            <Typography
                              sx={{
                                fontSize: 15,
                                fontWeight: 700,
                                color: 'rgba(0, 0, 0, 0.6)',
                                letterSpacing: '0.5px',
                              }}>
                              {`I/we hereby confirm that the funds injected/invested have been
                          legitimately and legally obtained/earned and the derivation and use of the
                          funds do not contravene applicable anti-money laundering and terrorist
                          financing legislation.`}
                            </Typography>
                          </Grid>
                          <KeyValue
                            title={'Source Of Funds'}
                            description={
                              SourceOfFundMaster[applicant.sourceOfFunds || ''] ||
                              applicant.sourceOfFunds
                            }
                          />
                        </>
                      )}
                      {applicant.sourceOfFundsLegitimacy && (
                        <Grid item xs={12} display="flex" alignItems={'flex-start'} my={2}>
                          <Checkbox defaultChecked disabled={true} />
                          <Typography
                            sx={{
                              fontSize: 15,
                              fontWeight: 700,
                              color: 'rgba(0, 0, 0, 0.6)',
                              letterSpacing: '0.5px',
                            }}>
                            {`I/we hereby confirm that the aforementioned information is true and
                          correct. I/we will also provide documentary evidence of the source of
                          funds if / when required.`}
                          </Typography>
                        </Grid>
                      )}
                      <KeyValue
                        title={'Is Investor a Person with Disability'}
                        description={YesNoMaster[applicant.isPhysicallyDisabled || '']}
                      />
                      {isPhysicallyChallenged(applicant.isPhysicallyDisabled) && (
                        <Grid item xs={12}>
                          <Notes displayContent="Our authorised representative will contact you for any assistance you may need." />
                        </Grid>
                      )}
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
